import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import HTMLPlayer from "components/HTMLPlayer";
import Placeholder from "components/Placeholder";
import LDJsonSchema from "components/LDJsonSchema";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";
import { videoAttributes } from "utils/videoPlayerUtils";

const Vertical = styled("div", {
  shouldForwardProp: (prop) => prop !== "isVertical",
})(({ theme, isVertical }) => ({
  ...(isVertical && {
    alignSelf: "center",
    height: 480,
    width: 270,
    margin: "auto",
    [theme.breakpoints.up("tablet")]: {
      height: 640,
      width: 360,
    },
  }),
}));

const PreviewVideoPlayer = ({ loading, templateGroup }) => {
  const { href } = window.location;
  const previewVideo = TemplateGroupPresenter.previewVideo(templateGroup);
  const thumbnail = TemplateGroupPresenter.posterUrl(templateGroup);
  const { loop, controls, autoplay, muted, isVertical, aspectRatio } = videoAttributes(templateGroup);

  const videoObjectSchema = {
    "@context": "http://schema.org",
    "@type": "VideoObject",
    "@id": href,
    name: TemplateGroupPresenter.name(templateGroup),
    uploadDate: TemplateGroupPresenter.uploadDate(templateGroup),
    thumbnailUrl: thumbnail,
    duration: TemplateGroupPresenter.duration(templateGroup),
    description: TemplateGroupPresenter.description(templateGroup),
    contentUrl: previewVideo,
  };

  const renderPlaceholder = () => {
    return (
      <Vertical isVertical={isVertical}>
        <Placeholder variant="rect" ratio={aspectRatio} data-testid="placeholder" />
      </Vertical>
    );
  };

  const renderPlayer = () => {
    return (
      <>
        <Vertical isVertical={isVertical}>
          <HTMLPlayer
            joinable={false}
            src={previewVideo}
            poster={thumbnail}
            autoplay={autoplay}
            controls={controls}
            loop={loop}
            muted={muted}
            aspectRatio={aspectRatio}
            templateGroup={templateGroup}
          />
        </Vertical>
        <LDJsonSchema schema={videoObjectSchema} />
      </>
    );
  };

  return loading ? renderPlaceholder() : renderPlayer();
};

PreviewVideoPlayer.propTypes = {
  loading: PropTypes.bool,
  templateGroup: TemplateGroupPresenter.shape(),
};

export default PreviewVideoPlayer;
